module.exports = __webpack_public_path__ + "static/img/ad8.d5ca6a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad8.png
// module id = Du9d
// module chunks = 12